import { render, staticRenderFns } from "./Section3.vue?vue&type=template&id=bcc950a2&scoped=true&"
import script from "./Section3.vue?vue&type=script&lang=js&"
export * from "./Section3.vue?vue&type=script&lang=js&"
import style0 from "./Section3.vue?vue&type=style&index=0&id=bcc950a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc950a2",
  null
  
)

export default component.exports